
export class SecurityGroup {

    public SecurityGroupId:string;

    public Name:string;

    public Description:string;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/security-group.ts